// extracted by mini-css-extract-plugin
export default {"root":"oHwnSnWJnP599uJiAxxw","wrap":"hFrqMMrRUc8R1uk9OeeP","image":"JmPrEi12ecR6rcgkDWKD","placeholder":"uNGRe0GZToXVkmR9gazL","overlay":"VZmo8u3tQdFpP8gcpKZM"};